//import Materials from './screens/index.vue';
const Materials = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const materialsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.MATERIAL_VIEW,
    PERMISSIONS_KEYS.MATERIAL_INSERT,
    PERMISSIONS_KEYS.MATERIAL_EDIT,
    PERMISSIONS_KEYS.MATERIAL_DELETE,
  ])
) {
  materialsRoutes.push({
    path: '/regras-da-prescricao/ativos',
    name: 'Cadastro / Consulta|Ingrediente Ativo',
    component: Materials,
    meta: {
      icon: 'fa-prescription-bottle',
      requiresAuth: true,
    },
  });
}

export { materialsRoutes };
